import { render, staticRenderFns } from "./DocPanel.vue?vue&type=template&id=37a6a02d&scoped=true"
import script from "./DocPanel.vue?vue&type=script&lang=js"
export * from "./DocPanel.vue?vue&type=script&lang=js"
import style0 from "./DocPanel.vue?vue&type=style&index=0&id=37a6a02d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a6a02d",
  null
  
)

export default component.exports